export default {
  title: 'Sesame Updates',
  items: [
    {
      title: 'Sesame 2026 Data & Data Viewer',
      description:
        'Expanded data library with multinational coverage across power generation and renewables. Modules now auto-select the most relevant data based on pathway location. Explore all available data in the new Data Viewer on module parameter pages.',
    },
    {
      title: 'CA-GREET & 45ZCF-GREET Configurations',
      description:
        'Transport modules now include pre-built data configurations for CA-GREET 4.0 and 45ZCF-GREET, making LCFS and 45Z pathway analyses significantly faster to configure.',
    },
    {
      title: 'Multi-Factor Authentication',
      description:
        'Accounts can now be secured with MFA using any TOTP-compatible authenticator app. Enable it from your account settings.',
    },
    {
      title: 'Total Emissions in Comparisons',
      description:
        'The emissions comparison chart can now show each case\u2019s absolute annual total alongside the existing carbon intensity view. Totals are reported in kg, tons or Mt CO\u2082e per year, and cases with different products can now be compared side by side.',
    },
    {
      title: 'Abatement Potential in Cost Comparisons',
      description:
        'The COAC comparison view now includes an Abatement Potential panel showing annual CO₂ avoided alongside cost of abatement.',
    },
    {
      title: 'Bug Fixes & Improvements',
      description:
        'We performed a sweeping review of modules and features, resolving some clerical issues. No major changes to module models or results.',
    },
  ],
};
